import { useEffect, useState } from "react";
import { CMCardChartTrackSocial } from "./card-chart-track-stats.styles";
import { ChartTrackSocialBars, ChartTrackSocialLine } from "./chart-track-stats.component";

const CardChartTrackSocial = ({icon, title, link, quantity, quantity_past_month, difference, chart_data_1, chart_data_2}) => {

    const [formattedQuantity, setFormattedQuantity] = useState("")
    const [formattedDifference, setFormattedDifference] = useState("")
    const [styleDifference, setStyleDifference] = useState("difference_text text_gray")
    const [formattedDate, setFormattedDate] = useState("")

    const chartColors = {
        chartmetric: {
            stroke: "#00ca90"
        },
        youtube: {
            stroke: "#750000"
        },
        spotify: {
            stroke: "#127500"
        },
        pandora: {
            stroke: "#006bd3"
        },
        airplay: {
            stroke: "#000000"
        }
    }

    useEffect(()=> {
        const date = new Date()
        const options = { 
            year: 'numeric', 
            month: 'short',
            day: 'numeric' 
        };
        const today = date.toLocaleDateString('en-US', options).replace(',', '');
        setFormattedDate("As of " + today)
    }, [])

    useEffect(() => {
        try {
            const value = parseFloat(quantity)
            setFormattedQuantity(formatValue(value))
        } catch (e){
            setFormattedQuantity("0")
            console.log(e)
        }
    }, [quantity])

    useEffect(() => {
        try {
            const value_difference = parseFloat(difference)
            const formattedStyle = 'difference_text ' + (value_difference > 0 ? 'text_green' : value_difference < 0 ? 'text_red' : 'text_gray')
            setStyleDifference(formattedStyle)

            const value_quantity_past_month = parseFloat(quantity_past_month)
            const percentage = (100 / value_quantity_past_month) * Math.abs(value_difference)
            const sign = value_difference > 0 ? '+' : value_difference < 0 ? '-' : ''
            const formattedDifference = `${sign} ${formatValue(difference.replace('-',''))} (${percentage.toFixed(2)}%)`
            setFormattedDifference(formattedDifference)
        }
        catch (e){
            console.log(e)
        }
    }, [difference, quantity_past_month])

    const formatValue = (value) => {
        let formattedValue =
            value >= 1000000000 ? (value/1000000000).toFixed(1).replace(/\.0$/, '') + 'B' :
            value >= 1000000 ? (value/1000000).toFixed(1).replace(/\.0$/, '') + 'M' :
            value >= 1000 ? (value/1000).toFixed(1).replace(/\.0$/, '') + 'K' :
            value
        return formattedValue
    }

    return (
        <CMCardChartTrackSocial>
            <div className="title_container">
                <img clasName="title_icon" width="20" src={require(`./../../Assets/CHART_ICONS/${icon}.svg`)} />
                <a href="#" className="title_text">{title}</a>
            </div>
            <label className="quantity">{formattedQuantity}</label>
            <div className="difference_container">
                <label className={styleDifference}>{formattedDifference}</label>
                <label className="past_month_text">Past month</label>
            </div>
            <label className="date_text">{formattedDate}</label>
            <div className="chart_container">
                <ChartTrackSocialLine style={chartColors[icon]} values={chart_data_1} />
                <ChartTrackSocialBars style={chartColors[icon]} values={chart_data_2} />
            </div>
        </CMCardChartTrackSocial>
    )
}

export default CardChartTrackSocial;